import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

/** Persist doc related tab in `?tab=` — plan/35. */
export function useDeskDocTab(defaultTab: string, allowed: readonly string[]) {
  const [searchParams, setSearchParams] = useSearchParams();
  const raw = searchParams.get("tab") ?? defaultTab;
  const tab = allowed.includes(raw) ? raw : defaultTab;

  const setTab = useCallback(
    (next: string) => {
      const id = allowed.includes(next) ? next : defaultTab;
      setSearchParams(
        (prev) => {
          const p = new URLSearchParams(prev);
          if (id === defaultTab) p.delete("tab");
          else p.set("tab", id);
          return p;
        },
        { replace: true },
      );
    },
    [allowed, defaultTab, setSearchParams],
  );

  return [tab, setTab] as const;
}
